// pageInside/payments/walletLabels.js -- translated labels for wallet states.
import { elakayAutoText } from "../dataElakay";

export const earningStateLabel = (state) => ({
  pending_delivery: elakayAutoText("h_pay_waiting_delivery", "Waiting for Delivery"),
  waiting_release: elakayAutoText("h_pay_waiting_release", "Waiting for Release"),
  available: elakayAutoText("h_pay_available_withdrawal", "Available for Withdrawal"),
  blocked: elakayAutoText("h_pay_blocked", "Blocked"),
  withdrawn: elakayAutoText("h_pay_withdrawn", "Withdrawn"),
  cancelled: elakayAutoText("h_pay_refunded", "Refunded / cancelled"),
  needs_review: elakayAutoText("h_pay_under_review", "Under review"),
}[state] || state);

export const withdrawalStatusLabel = (status) => ({
  requested: elakayAutoText("h_pay_wd_requested", "Requested"),
  pending: elakayAutoText("h_pay_wd_pending", "Pending"),
  processing: elakayAutoText("h_pay_withdrawal_in_progress", "Withdrawal in Progress"),
  paid: elakayAutoText("h_pay_withdrawal_completed", "Withdrawal Completed"),
  failed: elakayAutoText("h_pay_withdrawal_failed", "Withdrawal Failed"),
  cancelled: elakayAutoText("h_pay_wd_cancelled", "Cancelled"),
}[status] || status);

export const blockReasonLabel = (reason = "") => {
  if (reason === "return_requested") return elakayAutoText("h_pay_reason_return", "Return requested");
  if (reason === "dispute_opened") return elakayAutoText("h_pay_reason_dispute", "Dispute opened");
  if (reason === "partial_refund") return elakayAutoText("h_pay_reason_partial_refund", "Partial refund");
  if (reason === "paypal_capture_pending") return elakayAutoText("h_pay_reason_capture_pending", "Payment confirmation pending");
  if (reason === "split_exceeds_capture" || reason.startsWith("unverified_beneficiary")) return elakayAutoText("h_pay_reason_review", "Under review by Elakay");
  return reason;
};

// Why the balance is not withdrawable (server-computed reason).
export const unavailabilityMessage = (reason) => ({
  EARNINGS_AWAITING_DELIVERY: elakayAutoText("h_pay_err_awaiting_delivery", "Earnings are awaiting delivery confirmation."),
  EARNINGS_AWAITING_RELEASE: elakayAutoText("h_pay_err_awaiting_release", "Earnings are awaiting the 7-day release period."),
  EARNINGS_BLOCKED: elakayAutoText("h_pay_err_refund_dispute", "Refund or dispute in progress."),
  REFUND_RECOVERY_PENDING: elakayAutoText("h_pay_err_refund_recovery", "A refund is being recovered from your earnings."),
}[reason] || "");

// Server error codes -> translated messages (the server message is the fallback).
export const paymentErrorMessage = (error) => (error?.code === "INSUFFICIENT_AVAILABLE_BALANCE" && unavailabilityMessage(error.reason)
  ? `${elakayAutoText("h_pay_insufficient_balance", "Insufficient Available Balance")} — ${unavailabilityMessage(error.reason)}`
  : null) || ({
  PAYPAL_NOT_CONFIGURED: elakayAutoText("h_pay_err_paypal_not_configured", "PayPal account not configured."),
  PAYPAL_UNAVAILABLE: elakayAutoText("h_pay_err_paypal_unavailable", "PayPal is temporarily unreachable. Please try again."),
  PAYOUT_FUNDS_UNAVAILABLE: elakayAutoText("h_pay_err_payouts_unavailable", "PayPal Payouts unavailable."),
  PASSWORD_REQUIRED: elakayAutoText("h_pay_confirm_account_password", "Confirm your password"),
  PASSWORD_INCORRECT: elakayAutoText("h_pay_err_password", "Incorrect password."),
  TOO_MANY_ATTEMPTS: elakayAutoText("h_pay_err_attempts", "Too many attempts. Try again in a few minutes."),
  DELIVERY_CONFIRMATION_REQUIRED: elakayAutoText("h_pay_err_delivery_confirmation", "Delivery must be confirmed by the buyer or by the carrier tracking."),
  PAYPAL_DECLINED: elakayAutoText("h_pay_err_processing_failed", "Payment processing failed."),
  PAYPAL_NOT_AUTHORIZED: elakayAutoText("h_pay_err_processing_failed", "Payment processing failed."),
  INSUFFICIENT_AVAILABLE_BALANCE: elakayAutoText("h_pay_insufficient_balance", "Insufficient Available Balance"),
  WITHDRAWAL_METHOD_UNAVAILABLE: elakayAutoText("h_pay_withdrawal_method_unavailable", "Withdrawal Method Unavailable"),
  PAYMENT_METHOD_UNAVAILABLE: elakayAutoText("h_pay_method_unavailable", "Payment Method Unavailable"),
  WITHDRAWAL_IN_PROGRESS: elakayAutoText("h_pay_withdrawal_busy", "Another withdrawal is being prepared. Please wait a moment."),
  PAYOUT_ACCOUNT_NOT_VERIFIED: elakayAutoText("h_pay_account_not_verified", "Your payout account is not verified yet. Complete the Stripe verification first."),
  BANK_ACCOUNT_REQUIRED: elakayAutoText("h_pay_bank_required", "Add and select a bank account first."),
  BANK_ACCOUNT_NOT_FOUND: elakayAutoText("h_pay_bank_required", "Add and select a bank account first."),
  PAYPAL_ACCOUNT_REQUIRED: elakayAutoText("h_pay_paypal_required", "Add your PayPal account in Banking first."),
  ACCOUNT_SUSPENDED: elakayAutoText("h_pay_account_suspended", "Withdrawals are unavailable while your account is suspended."),
  AMOUNT_TOO_SMALL: elakayAutoText("h_pay_minimum", "The minimum withdrawal is $1.00."),
  PAYPAL_NOT_AVAILABLE_FOR_ORDER: elakayAutoText("h_pay_paypal_not_for_order", "PayPal is not available for this order. Please pay by card."),
}[error?.code] || error?.message || elakayAutoText("h_pay_err_processing_failed", "Payment processing failed."));
